import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { Grid, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionIndicator: {
    width: '4px',
    height: '24px',
    borderRadius: '2px',
    background: `linear-gradient(180deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
    marginRight: theme.spacing(1.5),
  },
  sectionTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1.5),
    },
  },
  sectionTitle: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    fontSize: '1rem',
  },
  rightActionContainer: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      '& > *': {
        width: '100%',
      },
    },
  },
}))

export const SecaoGenerica = (props) => {
  const { titulo, children, rightAction, spacing } = props
  const classes = useStyles()

  return (
    <Grid item container justifyContent="space-between" spacing={spacing} style={{ alignItems: 'start', marginBlock: '32px' }}>
      <Grid item md={12} sm={12} xs={12} className={classes.sectionTitleContainer}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className={classes.sectionIndicator} />
          <Typography variant="h5" className={classes.sectionTitle}>
            {titulo}
          </Typography>
        </div>
        {rightAction && <div className={classes.rightActionContainer}>{rightAction}</div>}
      </Grid>
      {children}
    </Grid>
  )
}

SecaoGenerica.propTypes = {
  titulo: PropTypes.string.isRequired,
  children: PropTypes.node,
  rightAction: PropTypes.node,
  spacing: PropTypes.number,
}
